export default "__VITE_ASSET__BGyZyLpY__"